/**
 * Сборка адресов API. Вынесено отдельным модулем без обращений к
 * import.meta.env, чтобы логику можно было проверить тестами вне сборки Vite.
 */

export type QueryValue = string | number | boolean | undefined | null;

/**
 * Приводит настройку VITE_API_URL к абсолютному адресу.
 *
 * В продакшене это относительный «/api»: фронтенд ходит на свой же origin
 * через nginx. Но `new URL(path, base)` требует абсолютную базу и на
 * относительной бросает TypeError — из-за этого в проде падали все запросы,
 * а страница выглядела просто пустой.
 */
export function resolveApiBase(apiUrl: string, origin: string): string {
  if (/^https?:\/\//i.test(apiUrl)) return stripTrailingSlash(apiUrl);

  const path = apiUrl.startsWith('/') ? apiUrl : `/${apiUrl}`;
  return stripTrailingSlash(`${stripTrailingSlash(origin)}${path}`);
}

export function buildUrl(
  base: string,
  path: string,
  query?: Record<string, QueryValue>,
): string {
  const url = new URL(path.startsWith('/') ? path.slice(1) : path, `${base}/`);

  if (query) {
    for (const [key, value] of Object.entries(query)) {
      if (value === undefined || value === null || value === '') continue;
      url.searchParams.set(key, String(value));
    }
  }

  return url.toString();
}

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}
